import { Inline } from '@superdispatch/ui';
import { Box, TextBox } from '@superdispatch/ui-lab';
import { ErrorIcon } from 'shared/icons/ErrorIcon';

export function ViewLoadInspectionNonVehiclePhotoTitle() {
  return (
    <Box
      position="absolute"
      top="20px"
      right="0"
      left="0"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Box
        backgroundColor="Dark500"
        borderRadius="small"
        paddingLeft="xxsmall"
        paddingRight="xxsmall"
        display="inline-flex"
        alignItems="center"
      >
        <Inline space="xxsmall" verticalAlign="center">
          <ErrorIcon />
          <TextBox color="white">Possibly Not a Vehicle</TextBox>
        </Inline>
      </Box>
    </Box>
  );
}
